import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Table,
  Card,
  CardBody,
} from "reactstrap"
import CardItem from "./CardItem"
import "./Style.scss"
import { adminPrefix } from "configs/routePrefix"
import Paginator from "components/Common/Paginator/Paginator"
import FilterForm from "./FilterForm"
import FilterIcon from "assets/images/filter.png"
import { useSelector } from "react-redux"
import SalesDeveloperService from "services/Admin/SalesDeveloperService"

const SalesDeveloperPage = (props) => {
  const salesDeveloperService = new SalesDeveloperService()
  const [showFilters, setShowFilters] = useState(false)
  const [filtersParams, setFilterParams] = useState(null)
  const [shouldGetData, setShouldGetData] = useState(false)
  const [active, setActive] = useState("all")
  const [searchWord, setSearchWord] = useState("")
  const [list, setList] = useState([])
  const [developerId, setDeveloperId] = useState(null)
  const [exportUrl, setExportUrl] = useState("")
  const AuthData = useSelector(state => state.Auth)
  const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: 1,
  })

  const addHandler = () => {
    props.history.push(`${adminPrefix}/sales-developer/sales-developer-create`)
  }

  const updateHandler = (id) => {
    props.history.push(`${adminPrefix}/sales-developer/sales-developer-update/${id}`)
  }

  const OnSearchChange = (e) => {
    const search = e.target.value
    setSearchWord(search)
  }

  useEffect(() => {
    // debounce solution to reduce request data from api
    const timeoutId = setTimeout(() => {
      const params = {}
      if (active != 'all') params['status'] = active === "active" ? 1 : 0
      if (searchWord.trim().length) params['keyword'] = searchWord
      if (developerId ?.length !== 0) params['developer_ids'] = developerId ?.map(developer => developer.value).join()
      setFilterParams({ ...params })
    }, 1000)
    return () => clearTimeout(timeoutId)
  }, [active, searchWord, developerId])

  useEffect(() => {
    const url = salesDeveloperService.getExportUrl(active, searchWord, developerId)
    setExportUrl(url)
  }, [active, searchWord, developerId])

  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Sales Developer</title>
        </MetaTags>
        <Container fluid>
          <Row className="mb-1">
            <Col md={6}>
              <h4>Manage Sales Developers</h4>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={searchWord}
                  onChange={(e) => OnSearchChange(e)}
                  placeholder="Search by sales developer name, phone number, email, I.D" />
              </div>
            </Col>
            <Col md={6}>
              <div className="d-md-flex justify-content-md-end mb-2">
                {isExist("developers.add") ? <button
                  className="btn btn-success btnHeight px-lg-4"
                  onClick={addHandler}
                >
                  Invite New Sales Developer
                 </button> : null}
              </div>
            </Col>

          </Row>
          <Row className="mb-4" >
            <Col md={6} sm={8} className="mb-3">
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "all" ? "#556ee6" : "#f4f4f4",
                  color: active == "all" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("all")
                }}
              >
                All
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "active" ? "#556ee6" : "#f4f4f4",
                  color: active == "active" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("active")
                }}
              >
                Active
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                  color: active == "deactive" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("deactive")
                }}
              >
                Deactive
                            </button>
            </Col>
            <Col md={6} sm={4} className="mb-3 d-flex flex-row-reverse">

              <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                setShowFilters(!showFilters)
              }}><img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
            </Col>
          </Row>
          {showFilters ? <FilterForm
            showFilters={showFilters}
            setDeveloperId={setDeveloperId}
            developerId={developerId}
            setShowFilters={setShowFilters}
          /> : null}
          <div>
            <Card className="w-100 mt-4">
              <CardBody>
                <div className='py-3'>
                  <div>
                    <div className="table-responsive">
                      <Table>
                        <thead>
                          <tr className='bgHeaderTable'>
                            <th className='font-size-14'>I.D</th>
                            <th className='font-size-14'>Sales Developer</th>
                            <th className='font-size-14'>Developer</th>
                            <th className='font-size-14'>Email</th>
                            <th className='font-size-14'>Phone Number</th>
                            <th className='font-size-14'>Status</th>
                            <th className='font-size-14'></th>
                          </tr>
                        </thead>
                        <tbody>

                          {list.map((item, index) => <CardItem
                            key={index}
                            index={index}
                            {...item}
                            item={item}
                            Service={SalesDeveloperService}
                            updateHandler={() => updateHandler(item.id)}
                            setShouldGetData={setShouldGetData}
                          />)}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Row className="d-flex justify-content-end">
              <Col className="d-flex justify-content-between" md={12} sm={12}>
                <Paginator
                  service={salesDeveloperService}
                  pageOptions={pageOptions}
                  setData={(data) => setList([...data])}
                  setPageOptions={setPageOptions}
                  filtersParams={filtersParams}
                  shouldGetData={shouldGetData}
                  setShouldGetData={setShouldGetData}
                />
              </Col>
            </Row >
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SalesDeveloperPage